'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default ['$scope', '$uibModalInstance', 'user', '$security', 'RoleRestService', 'UserService', 'StaffService',
    function ($scope, $modalInstance, user, $security, RoleRestService, UserService, StaffService) {

        let oldRoles = [];

        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.editing = editing;
        $scope.checkLogin = checkLogin;
        $scope.isShowEdit = isShowEdit;
        $scope.selectStaff = selectStaff;
        $scope.onSelectRole = onSelectRole;
        $scope.isAllowSelectUser = isAllowSelectUser;
        $scope.tooltipContent = null;

        // инициализация
        init();

        // region Function

        function init() {

            $scope.staffFilters = ["'user' EQ 'null'"];

            $scope.edit = false;
            $scope.uniqueLogin = true;

            if (user != null)
                user.accountLocked = !user.accountNonLocked;

            $scope.user = angular.copy(user);

            if (user == null || angular.equals({}, user) || user.id == null) {
                $scope.title = "Создание нового пользователя";
                $scope.edit = true;
            } else {
                $scope.title = 'Редактирование пользователя "' + $scope.user.username + '"';
                $scope.edit = false;
            }

            RoleRestService.get(null, (data) => {
                $scope.roles = data._embedded;
                $scope.user = angular.copy(user);
                oldRoles = angular.copy(user.authorities);
                if (user.authorities != null && Array.isArray(user.authorities)) {
                    for (let authority of user.authorities) {
                        let role = $scope.roles.find(r => r.id == authority.id);
                        if (role) {
                            role.author = authority.author;
                            role.createDate = authority.createDate;
                        }
                    }
                }
            });
        }

        function ok() {
            $modalInstance.close($scope.user);
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        function selectStaff() {
            StaffService.select($scope.user.staff, ["'user' EQ 'null'"], {}).result.then(function (data) {
                $scope.user.staff = data;
            });
        }

        function isAllowSelectUser() {
            if (!$scope.user) return false;
            return !!($scope.user.authorities || []).length;
        }

        function onSelectRole($item, $model) {
            let role = null;

            if (Array.isArray(oldRoles)) {
                role = oldRoles.find(r => r.id == $item.id);
            }

            if (!role) {
                $item.createDate = new Date();
                $item.author = $security.getUser();
            }
        }

        function checkLogin(login) {
            if (login != null && login.trim() != "") {
                UserService.api.isUniqueLogin({
                    id: $scope.user.id,
                    login: login
                }, (data) => $scope.uniqueLogin = data._embedded);
            } else {
                $scope.uniqueLogin = true;
            }
        }

        /**
         * Редактировать
         */
        function editing() {
            $scope.edit = true;
        }

        /**
         * Отображать кнопку редактировать?
         * @returns {boolean|*}
         */
        function isShowEdit() {
            return !$scope.edit && $security.isAllowWrite('/users');
        }

        // endregion

        // region Watcher

        $scope.$watch('user.accountLocked', function () {
            $scope.user.accountNonLocked = !$scope.user.accountLocked;
        });

        $scope.$watch('user.authorities', function (newValue) {
            $scope.staffFilters = ["'user' EQ 'null'"];
            if (!Array.isArray(newValue) || !newValue.length) {
                $scope.tooltipContent = "Необходимо выбрать роль пользователя";
                return;
            }
            $scope.staffFilters.push(`'role' IN '${newValue.map(n => n.authority).join(',')}'`);
            $scope.tooltipContent = null;
        });

        // endregion

    }];